import './index.scss';
import React from 'react';
import Loader from 'react-loaders';
import { Link } from 'react-router-dom';
const NoPageFound = ()=>{
    return(
        <div className="container nopagefound">
            <div className="text-zone">
                <h1>
                Something Went Wrong
                </h1>
                <p >Looks like the page you are looking for doesn't exist</p><br />
                <Link to="/" className='back-button'>Go Back</Link>
                
            </div>
            <Loader type="pacman" />
        </div>
    )
}
export default NoPageFound;